// src/components/Map/MapContainer.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Map, NavigationControl } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';


import MapMarkers from './MapMarkers';
import PipelineLayer from './PipelineLayer';
import ExpensesLayer from './ExpensesLayer';

import './MapContainer.css';

const MAPBOX_TOKEN = 'pk.eyJ1IjoiaWdvcnNlcmdlZXZpY2hpc2l0IiwiYSI6ImNtNm5oMXd0aTA2bnQycXNnODlycjJtcGEifQ.NSbRJio0u0pnKfQkBluU_Q';

const MapContainer = () => {
  const location = useLocation();
  const [viewport, setViewport] = useState(() => {
    const saved = localStorage.getItem('mapViewport');
    return saved
      ? JSON.parse(saved)
      : {
          longitude: 88.193,
          latitude: 69.3515,
          zoom: 13.4,
          pitch: 0,
          bearing: 57
        };
  });

  useEffect(() => {
  localStorage.setItem('mapViewport', JSON.stringify(viewport));
}, [viewport]);

  const mapRef = useRef(null);

  const handleMapLoad = () => {
    const map = mapRef.current.getMap();

    // Вывод всех слоёв карты в консоль
    const layerIds = map.getStyle().layers.map(layer => layer.id);
    console.log('Слои карты:', layerIds);

    // Перемещаем слой с домами поверх всех
    try {
      /* map.setPaintProperty('building', 'fill-opacity', 0.0); */ // убрать заливку
/*       map.setLayoutProperty('hillshade', 'visibility', 'none'); // отключить рельеф
      map.setLayoutProperty('landcover', 'visibility', 'none');
      map.setLayoutProperty('landuse', 'visibility', 'none'); */
    } catch (e) {
      console.warn('Некоторые слои не найдены');
    }
  };

  const getLayer = () => {
    if (location.pathname === '/collectors') return <MapMarkers />;
    if (location.pathname === '/pipeline') return <PipelineLayer />;
    if (location.pathname === '/expenses') return <ExpensesLayer />;
    return null;
  };

  const getStyle = () => {
    if (location.pathname === '/pipeline') return 'mapbox://styles/mapbox/dark-v11';
    if (location.pathname === '/expenses') return 'mapbox://styles/mapbox/dark-v11';
    return 'mapbox://styles/mapbox/dark-v11';
  };

  return (
    <div className="map-wrapper">
      <div className="mapbox-container">
        <Map
          ref={mapRef}
          onLoad={handleMapLoad}
          {...viewport}
          onMove={(evt) => setViewport({ ...viewport, ...evt.viewState })}
          mapboxAccessToken={MAPBOX_TOKEN}
          mapStyle={getStyle()}
          className="map-container"
          dragRotate={false}
          touchRotate={true}
          doubleClickZoom={false}
          scrollZoom={true}
          boxZoom={false}
          keyboard={false}
          onClick={(e) => {
            const { lng, lat } = e.lngLat;
            console.log(`{ latitude: ${lat},  longitude: ${lng} }`);
          }}
        >
          <NavigationControl position="bottom-right" showZoom={true} />
          {getLayer()}
        </Map>
      </div>
    </div>
  );
};

export default MapContainer;
